module.exports = __webpack_public_path__ + "img/Khipu.1084861.svg";